import { useSegment, useSegmentAdmin } from 'hooks/analytics/segment'

export const Segment = () => {
  useSegment()
  useSegmentAdmin()
  return null
}
